import { atom } from 'recoil';

export const toggleQuickConfig = atom({
    key: 'aws-oracle-19c-toggleQuickConfig',
    default: false,
});

export const quickConfigDetails = atom({
    key: 'aws-oracle-19c-quickConfigDetails',
    default: undefined,
});

export const defaultVmDataDisk = atom({
    key: 'aws-oracle-19c-defaultVmDataDisk',
    default: undefined,
});

export const toggleSspModels = atom({
    key: 'aws-oracle-19c-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDiskOpen: false,
        isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
    },
});

export const isExpectedDbSizeValid = atom({
    key: 'oracle-19c-isExpectedDbSizeValid',
    default: false,
});

export const isEnvDetailsLoading = atom({
    key: 'aws-oracle-19c-isEnvDetailsLoading',
    default: false,
});

export const isDataDiskLoaded = atom({
    key: 'aws-oracle-19c-isDataDiskLoaded',
    default: false,
});

export const isConfigDiskFulfilled = atom({
    key: 'aws-oracle-19c-isConfigDiskFulfilled',
    default: false,
});

export const defaultOsDiskType = atom({
    key: 'aws-oracle-19c-defaultOsDiskType',
    default: undefined,
});

export const isMandatoryTagsFullfilled = atom({
    key: 'aws-oracle-19c-isMandatoryTagsFullfilled',
    default: false,
});

export const orderId = atom({
    key: 'aws-oracle-19c-orderId',
    default: '',
});

export const isValidOwners = atom({
    key: 'aws-oracle-19c-isValidOwners',
    default: {
        isvalidAppOwner: true,
    },
});

export const toggleCurrentServer = atom({
    key: 'aws-oracle-19c-toggleCurrentServer',
    default: false,
});

export const CurrentServerDetails = atom({
    key: 'aws-oracle-19c-CurrentServerDetails',
    default: null,
});

export const isDBNameValid = atom({
    key: 'oracle-19c-isDBNameValid',
    default: false,
});

export const sspSubmitOrder = atom({
    key: 'aws-oracle-19c-sspOrder',
    default: {
        // Application Section
        appProfile: null,
        drPriority: null,
        entityDetails: null,
        sector: null,
        sectorDetail: null,
        department: null,
        appRegion: null,
        environment: null,
        landingZoneDetails: null,
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,
        appTier: null,
        appTierCode: null,
        microService: null,
        microServiceDetails: null,
        microServiceOptionsAvailable: null,

        // Resource Section
        osImage: null,
        awsAccount: null,
        vpcId: null,
        availabilityZone: null,
        subnetId: null,
        isSubnetIpExhausted: false,
        ec2InstanceType: null,
        quantity: 1,
        vmType: 'Windows',
        retiringServerSysId: null,
        retiringServerName: null,
        disposalReason: null,
        scheduledRetirement: null,
        serverRefresh: 'no',
        billingEntity: null,
        billingEntityDetails: null,
        domain: null,
        adous: null,
        adousDetails: null,
        vcpus: null,
        vcpusCoreCount: null,
        metallic: null,

        // SQL Instance Section
        sqlVersion: null,
        serverCollation: null,
        serviceInstalled: [],

        // Oracle Instance Section
        oracleVersion: '19C',
        dbCharacterSet: null,
        dbNationalCharSet: null,

        // Disk configuration and Database
        maxDataDiskCount: 8,
        dataDisksCount: null,
        dataDisks: [],
        defaultDataDisks: [],
        expDBSize: null,
        databaseName: '',
        isManualDBName: false,

        // Security Group Section
        componentName: null,
        componentNameDetails: null,
        isSecurityGroupRequired: false,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'aws-oracle-19c-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'aws-oracle-19c-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 'aws-oracle-19c-isValidProvisioningForm',
    default: false,
});
export const isAppShortNameValid = atom({
    key: 'aws-oracle-19c-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'aws-oracle-19c-isAppShortNameExist',
    default: false,
});
